export default function ToolTip({
  tooltipData,
  tooltipVisible,
  setTooltipVisible,
}) {
  return (
    <>
      {tooltipData && tooltipVisible && (
        <div
          // className={`tooltip ${tooltipVisible ? "visible" : ""}`}
          onClick={() => setTooltipVisible(false)}
          style={{
            // height:40,
            // width: 140,
            width: "20%",
            minWidth: 300,
            padding: "1%",
            borderRadius: 10,
            background: "#ff0a",
            position: "absolute",
            border: "1px solid black",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            elevation: 3,
            // left: tooltipData.left-40,
            left: tooltipData.left,
            // left: 55,
            // top: tooltipData.top+140,
            top: tooltipData.top,
            // top: 70,
          }}
        >
          <h3>{tooltipData.district}</h3>
          <ol>
            {tooltipData?.events?.map((value, index) => {
              return (
                <>
                  <li key={index}>
                    <strong>{value?.venue}</strong>
                    <br />
                    <p>{value?.games?.join(", ")}</p>
                    <hr style={{ border: "1px dotted black", margin: "1px 0" }} />
                  </li>
                </>
              );
            })}
          </ol>
          {/* {tooltipData.name} */}
          {/* <br />
          {tooltipData.population} */}
        </div>
      )}
    </>
  );
}
